import React from 'react';
import { styles } from './styles';
export function GridDisabledOverlay() {
    return (React.createElement("div", { className: styles.disableOverlay, "data-selector-id": 'grid-core-disabled-overlay' }));
}
//# sourceMappingURL=GridDisabledOverlay.js.map